module.exports = __webpack_public_path__ + "static/media/project-settings.2d1c587b.svg";